export function isCheckoutExitUrl(url: string): boolean {
  const lower = String(url || '').toLowerCase();
  return (
    lower.includes('/api/payments/mpgs/return') ||
    lower.includes('/api/payments/mpgs/cancel') ||
    lower.includes('mpgs_return=') ||
    lower.includes('mpgs_cancel=') ||
    lower.includes('resultindicator=')
  );
}

export function isCheckoutCancelUrl(url: string): boolean {
  const lower = String(url || '').toLowerCase();
  return lower.includes('/api/payments/mpgs/cancel') || lower.includes('mpgs_cancel=');
}

export function cartPathFromCheckoutExit(rawUrl: string): string {
  let params: URLSearchParams;
  try {
    params = new URL(rawUrl).searchParams;
  } catch {
    params = new URLSearchParams();
  }
  const cancel = isCheckoutCancelUrl(rawUrl);
  const next = new URLSearchParams();
  next.set(cancel ? 'mpgs_cancel' : 'mpgs_return', '1');
  const gatewayOrderId =
    params.get('gateway_order_id') ||
    params.get('order.id') ||
    (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('mpgsGatewayOrderId') : '') ||
    '';
  if (gatewayOrderId) next.set('gateway_order_id', gatewayOrderId);
  const resultIndicator = params.get('resultIndicator') || '';
  if (resultIndicator) next.set('resultIndicator', resultIndicator);
  const pendingSubscription =
    typeof sessionStorage !== 'undefined' && sessionStorage.getItem('mpgsPendingSubscription');
  const path = pendingSubscription ? '/profile' : '/cart';
  return `${path}?${next.toString()}`;
}
